import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=79df0b2e&scoped=true&"
import script from "./Sections.vue?vue&type=script&lang=js&"
export * from "./Sections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79df0b2e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections.vue
// module id = null
// module chunks = 